<a class="xvi-link" (click)="handleLinkClick()">{{ text | translate }}</a>
